// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","questionsContainer":"App_questionsContainer__lzz1y","solutionContainer":"App_solutionContainer__ZgEdG"};